import AuthService from '@/service/AuthService'
import SamplingService from '@/service/SamplingService'
import store from '@/store'

export default function(to, from, next) {
    console.log('[Sample Guard]:[ASYNC] Guarding start.')

    if (SamplingService.isSamplingCampaign(store) && !SamplingService.isSampleStored(store)) {
        const sampleFromLocalStorage = SamplingService.localStorage().getSample()

        console.log('[Sample Guard] Is Sampling campaign but not stored.')

        if (!sampleFromLocalStorage) {
            return next()
        }

        console.log('[Sample Guard] store is not empty')

        if (sampleFromLocalStorage.isDone && sampleFromLocalStorage.isDone === true) {
            console.log('[Sample Guard] From store is done')

            AuthService.logout(store, 'master', () => {
                window.location.href = '/'
                
                return next({ name: 'index' })
            })
        }
        else {
            SamplingService.storeSample(store, sampleFromLocalStorage)
        }
    }
    else if ((to.name === 'zgody' || to.name === 'kupon') && SamplingService.isSamplingCampaign(store)) {
        let obj = {}

        obj = Object.assign({
            sampleId: store.getters['apiSample/selectedSampleId']
        }, store.getters['apiSample/sample'])

        SamplingService.localStorage().saveSample(obj)
    }

    console.log('[PageLayoutChanger]:[ASYNC] Guarded.')

    return next()
}